module.exports = __webpack_public_path__ + "static/media/IMG_9082.d261e6c3.JPG";